<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (dataExportToExcel)="exportToExcel()"(tabledata)="getTableData()" [displayData]="displayData"
                   [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable" [showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Create URL</div>

    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="moduleSelected"
                    (change)="onModuleChange($event.target.selectedIndex)">
                <option *ngFor="let module of modules" [value]="module.id">{{module.MODULENAME}}</option>
            </select>
        </div>
<!--        <div class="form-group font-13">-->
<!--            <mat-radio-group (change)="onButtonChange($event)">-->
<!--                <mat-radio-button value="N" [checked]="true">New URL Key</mat-radio-button>-->
<!--                <mat-radio-button value="E">Existing URL Key</mat-radio-button>-->
<!--            </mat-radio-group>-->
<!--        </div>-->
        <div class="form-group" [hidden]="isHidden">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="urlKey"
                   placeholder="Enter Url Key">
        </div>
        <div class="form-group" [hidden]="!isHidden">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="keySelected">
                <option *ngFor="let key of urlKeys" [value]="key.URLKEY">{{key.URLKEY}}</option>
            </select>
        </div>
        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="url"
                   placeholder="Enter Url ">
        </div>


        <div class="form-group">
            <textarea class="form-control radius-0 font-13" [(ngModel)]="urlDesc"
                      placeholder="Url Description"></textarea>
        </div>

    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
      <div class="modal-title">Search</div>
  
    </div>
    <div class="modal-body">
  
        <div class="form-group mar_top">
            <input type="text" class="form-control radius-0 font-13" placeholder=" Enter URL Key"
                   [(ngModel)]="urlSelected"
                   matInput [formControl]="searchData"[matAutocomplete]="auto"
                  >
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getDetails()">
                <mat-option *ngIf="isLoading" class="is-loading">
                    <mat-spinner diameter="50"></mat-spinner>
                </mat-option>
                <ng-container *ngIf="!isLoading">
                    <mat-option *ngFor="let urls of urls" [value]="urls.urlKey">
                      {{ urls.urlKey }} 
                    </mat-option>
                </ng-container>
            </mat-autocomplete>
        </div>
      
        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" placeholder="URL" readonly
                   [(ngModel)]="urlName">
        </div>
  
      
  
  
    </div>
    <div class="modal-footer pad-8">
  
            <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
            <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  
    </div>
  
    </ng-template>
<notifier-container></notifier-container>
